module.exports = __webpack_public_path__ + "static/media/orderCard.704e92d7.svg";